/// <amd-module name="Feed/Legacy/Types/IMultiCommandDropdownVersions" />
import { PackageVersion } from "Feed/Common/Contracts/Feed";

export interface IMultiCommandDropdownVersions {
    packageId: string;
    versions: PackageVersion[];
}
